export interface IElementDetails {
	id: number;
	label: string;
	link: string;
}
interface IProjectElementsEntity {
	publications: Array<IElementDetails>;
	expositions: Array<IElementDetails>;
	dashboards: Array<IElementDetails>;
	medias: Array<IElementDetails>;
	maps: Array<IElementDetails>;
	datablocks: Array<IElementDetails>;
	entities: Array<IElementDetails>;
	depots: Array<IElementDetails>;
	connectors: Array<IElementDetails>;
	rankings: Array<IElementDetails>;
	exportTemplates: Array<IElementDetails>;
	exposedDatablocks: Array<IElementDetails>;
	formulas: Array<IElementDetails>;
	grids: Array<IElementDetails>;
	charts: Array<IElementDetails>;
	timelines: Array<IElementDetails>;
	handle: Array<IElementDetails>;
}

const entityDefaults: IProjectElementsEntity = {
	publications: [],
	expositions: [],
	dashboards: [],
	medias: [],
	maps: [],
	datablocks: [],
	entities: [],
	depots: [],
	connectors: [],
	rankings: [],
	exportTemplates: [],
	exposedDatablocks: [],
	formulas: [],
	grids: [],
	charts: [],
	timelines: [],
	handle: [],
};

export class ProjectElementsEntity implements IProjectElementsEntity {
	public publications = entityDefaults.publications;
	public expositions = entityDefaults.expositions;
	public dashboards = entityDefaults.dashboards;
	public medias = entityDefaults.medias;
	public maps = entityDefaults.maps;
	public datablocks = entityDefaults.datablocks;
	public entities = entityDefaults.entities;
	public depots = entityDefaults.depots;
	public connectors = entityDefaults.connectors;
	public rankings = entityDefaults.rankings;
	public exportTemplates = entityDefaults.exportTemplates;
	public exposedDatablocks = entityDefaults.exposedDatablocks;
	public formulas = entityDefaults.formulas;
	public grids = entityDefaults.formulas;
	public charts = entityDefaults.charts;
	public timelines = entityDefaults.timelines;
	public handle = entityDefaults.handle;

	public static build(
		params: Partial<IProjectElementsEntity> = {}
	): ProjectElementsEntity {
		const instance = new ProjectElementsEntity();
		instance.publications = params.publications ?? entityDefaults.publications;
		instance.expositions = params.expositions ?? entityDefaults.expositions;
		instance.dashboards = params.dashboards ?? entityDefaults.dashboards;
		instance.medias = params.medias ?? entityDefaults.medias;
		instance.maps = params.maps ?? entityDefaults.maps;
		instance.datablocks = params.datablocks ?? entityDefaults.datablocks;
		instance.entities = params.entities ?? entityDefaults.entities;
		instance.depots = params.depots ?? entityDefaults.depots;
		instance.connectors = params.connectors ?? entityDefaults.connectors;
		instance.rankings = params.rankings ?? entityDefaults.rankings;
		instance.exportTemplates =
			params.exportTemplates ?? entityDefaults.exportTemplates;
		instance.exposedDatablocks =
			params.exposedDatablocks ?? entityDefaults.exposedDatablocks;
		instance.formulas = params.formulas ?? entityDefaults.formulas;
		instance.grids = params.grids ?? entityDefaults.grids;
		instance.charts = params.charts ?? entityDefaults.charts;
		instance.timelines = params.timelines ?? entityDefaults.timelines;
		instance.handle = [
			...instance.timelines,
			...instance.charts,
			...instance.grids,
			...instance.medias,
			...instance.maps,
		];
		return instance;
	}
}
